export default function BottomSheet({
  children,
  actionButtons,
  activate = false,
  onClose,
}) {
  return (
    <>
      {activate && <div className="bottom-sheet-overlay" onClick={onClose} />}
      <div
        className={
          activate
            ? "bottom-sheet-container active-bottom-sheet"
            : "bottom-sheet-container"
        }
      >
        <div className="bottom-sheet-wrapper">
          <div className="remove-active-sheet" onClick={onClose}>
            &#10005;
          </div>
          <div className="bottom-sheet-content">{children}</div>
        </div>
        <div className="bottom-sheet-buttons">{actionButtons()}</div>
      </div>
    </>
  );
}
